import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
// @mui
import { Box, Stack, Dialog, Grid, Button, AppBar, Typography, Container, Slide } from '@mui/material';
// components
import { useSettingsContext } from 'src/components/settings/context';
import { setCurrentTreatmentDataGlobal } from 'src/redux/slices/multiTreatment';
import { AddAppointmentBookedPopup } from '../dialogPopUp';
import { clearLead } from '../../redux/slices/lead';
import { dispatch } from '../../redux/store';
import { commonDialogHeaderStyle, onBoardDialogHeader, reminderDialogStyle, reminderTitleStyle, cancelBoxStyle, reminderStackStyle } from '../../styles/ScheduleReminder';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function OpenAppointmentBookedPopup({ open, onClose, treatmentId, headerButtons, leadId, onAppointmentBookClose }) {
    const settings = useSettingsContext();

    const handleClose = async () => {
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        onClose();
    };

    return (
        <Dialog
            fullScreen
            TransitionComponent={Transition}
            open={open}
            onClose={handleClose}
            sx={reminderDialogStyle}
        >
            <AppBar sx={headerButtons ? commonDialogHeaderStyle : onBoardDialogHeader}>
                <Typography
                    sx={reminderTitleStyle}
                    variant="h6"
                    component="div"
                >
					Book an appointment
                </Typography>
                {headerButtons &&
					<Box sx={cancelBoxStyle}>
					    <Button
					        color="inherit"
					        variant='outlined'
					        style={{ borderColor: '#FFFFFF', color: '#fff' }}
					        onClick={() => { onAppointmentBookClose(); }}
					    >
							Close
					    </Button>
					</Box>
                }
            </AppBar>
            <Stack spacing={0} sx={{ ...reminderStackStyle, pt: { md: '72px', xs: '72px' }, pb: { md: '100px', xs: '100px' } }}>
                <Grid container spacing={1} sx={{ maxWidth: '1088px', margin: 'auto' }}>
                    <Container
                        maxWidth={settings.themeStretch ? false : 'xl'}
                    >
                        <AddAppointmentBookedPopup handleClose={handleClose} treatmentId={treatmentId} leadId={leadId} />
                    </Container>
                </Grid>
            </Stack>
        </Dialog>
    );
}

OpenAppointmentBookedPopup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    treatmentId: PropTypes.any,
    headerButtons: PropTypes.bool,
    leadId: PropTypes.any,
    onAppointmentBookClose: PropTypes.any,
};